export default "__VITE_ASSET__c11e62cf__"